import { render } from "./Timer.vue?vue&type=template&id=b8e898a4"
import script from "./Timer.vue?vue&type=script&lang=ts"
export * from "./Timer.vue?vue&type=script&lang=ts"
script.render = render

export default script